import type { Messages } from '@/features/locale/messages'

export type MobileBrowsePageTitle = {
  title: string
}

/** Título de cabecera browse móvil según la ruta actual. */
export function resolveMobileBrowsePageTitle(
  pathname: string,
  pageTitles: Messages['pageTitles'],
): MobileBrowsePageTitle {
  if (pathname === '/') return { title: pageTitles.home }
  if (pathname === '/explore') return { title: pageTitles.explore }
  if (pathname === '/markets') return { title: pageTitles.explore }
  if (pathname === '/portfolio' || pathname.startsWith('/portfolio/')) return { title: pageTitles.portfolio }
  if (pathname === '/history') return { title: pageTitles.movements }
  if (pathname === '/liquidity' || pathname.startsWith('/liquidity/')) return { title: pageTitles.pool }
  if (pathname === '/pool') return { title: pageTitles.positions }
  if (pathname.startsWith('/token/')) return { title: pageTitles.token }
  if (pathname === '/about') return { title: pageTitles.about }
  if (pathname === '/legal') return { title: pageTitles.legal }
  if (pathname === '/contact') return { title: pageTitles.contact }
  if (pathname === '/bridge') return { title: pageTitles.bridge }
  if (pathname === '/design-system') return { title: pageTitles.designSystem }
  if (pathname === '/settings' || pathname.startsWith('/settings/')) return { title: pageTitles.settings }

  const segment = pathname.split('/').filter(Boolean)[0]
  if (segment) {
    return { title: segment.charAt(0).toUpperCase() + segment.slice(1) }
  }

  return { title: pageTitles.fallback }
}
